var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 15.4001L12.9 19.4001C12.5 19.7001 12 19.4001 12 19.0001V11.0001C12 10.5001 12.5 10.2001 12.9 10.5001L20.2 14.5001C20.5 14.8001 20.5 15.2001 20.2 15.4001Z",
    fill: "#848484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8 8.8002C21.8 6.0002 18.6 4.2002 15 4.2002C8.99998 4.3002 4.09998 9.1002 4.09998 15.1002C4.09998 16.0002 4.19998 16.8002 4.39998 17.6002",
    stroke: "#848484",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8.2001L24 9.1001L23.8 4.6001",
    stroke: "#848484",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29993 21.5002C8.29993 24.3002 11.4999 26.1002 15.0999 26.1002C21.0999 26.1002 25.9999 21.2002 25.9999 15.2002C25.9999 14.3002 25.8999 13.5002 25.6999 12.7002",
    stroke: "#848484",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 22.1002L6.09998 21.2002L6.29998 25.7002",
    stroke: "#848484",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.d1d9c55c106c6f90d457ccec457dac19.svg";
export { ForwardRef as ReactComponent };